import {has, isBoolean, isEmpty} from "lodash"
import {DigitalDocumentFieldSetUp} from "types/tasks"

export const useConditionalField = () => {
    const getFieldValue = (field) => {
        if (!field) {
            return null
        }
        if (!field.isYourField) {
            return field.type === DigitalDocumentFieldSetUp.SELECT
                ? field.fieldValues.find((item) => item.option === field.value)?.id
                : field.value
        }
        return field.type === DigitalDocumentFieldSetUp.SELECT ? field.value?.id : field.id
    }

    const checkFieldCanShow = ({field, fields}) => {
        if (isEmpty(field?.parsedDependencies)) {
            return true
        }
        return field.parsedDependencies.some((dependenceField) => {
            const dependenceFieldData = fields.find((item) => item.uuid === dependenceField.uuid)
            const dependenceFieldsWithParentData = fields.filter((item) => item.parentUuid === dependenceField.uuid)
            if (dependenceFieldData && !checkFieldCanShow({field: dependenceFieldData, fields})) {
                return false
            }
            if (isBoolean(dependenceField.value)) {
                if (dependenceFieldData && has(dependenceFieldData, "value")) {
                    return !!dependenceFieldData.value
                }
                if (!isEmpty(dependenceFieldsWithParentData)) {
                    return dependenceFieldsWithParentData.some((item) => !!item.value)
                }
                return false
            }

            const dependenceFieldWithParentData = dependenceFieldsWithParentData.find(
                (item) => item.uuid === dependenceField.value
            )
            if (dependenceFieldData && dependenceFieldData?.value) {
                return getFieldValue(dependenceFieldData) === dependenceField.value
            }
            if (dependenceFieldWithParentData && dependenceFieldWithParentData?.value) {
                return getFieldValue(dependenceFieldWithParentData) === dependenceField.value
            }
            return false
        })
    }
    return {checkFieldCanShow}
}
